// Shared thresholds for gating Algolia search requests: wait for a typing
// pause and require a minimum query length before searching, to cut down on
// request volume. Used by both the header autocomplete (GlobalContext.tsx,
// Products.tsx, Form.tsx) and the InstantSearch results page (SearchBox.tsx).
export const SEARCH_DEBOUNCE_MS = 500;
export const MIN_QUERY_LENGTH = 3;
